import React from "react";
import { connect } from "react-redux";
import { Form, Formik } from "formik";
import { Button, Tab, Tabs } from "react-bootstrap";
import Select from "react-select";
import { NumericFormat as NumberFormat } from "react-number-format";

import {
  history,
  MyToolTip,
  prepareDataSearch,
  ProductoDP,
  TIPO_REPUESTO,
} from "../../_helpers";
import { productoActions, traerPalabrasTabla } from "../../_actions";
import MiTabla from "../../_helpers/MiTabla";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { busquedaActions } from "../../_actions/busqueda.actions";
import { productoService } from "../../_services";
import alertService from "../../_services/cart/alert.service";
import authService from "../../_services/cart/authService";
import productoServiceTs from "../../_services/cart/producto.service";
import FiltrosDashboard from "../includes/FiltrosDashboard";
import { NavBarLateral } from "../vendedor/NavBarLateral";
import { ResumenPublicacionModal } from "../includes/ResumenPublicacionModal";
import { buscadorService } from "../../_services";

const tableRefActivas = React.createRef();
const tableRefFinalizadas = React.createRef();
const tableRefPausadas = React.createRef();
const bagRef = React.createRef();

const SOLAPAS = [
  { estado: "ACTIVA", titulo: "Activas" },
  { estado: "FINALIZADA", titulo: "Finalizadas" },
  { estado: "PAUSADA", titulo: "Pausadas" },
];

const refDe = (estado) => {
  if (estado === "ACTIVA") return tableRefActivas;
  if (estado === "FINALIZADA") return tableRefFinalizadas;
  return tableRefPausadas;
};

/**
 * Publicaciones de todos los vendedores, para el back office.
 *
 * Es el mismo listado que ve el vendedor en /vendedor/productos pero por el carril
 * /api/admin/producto: suma la columna y el filtro de vendedor, y desde acá se crea
 * o se edita en nombre de un vendedor (FormProducto en modo admin).
 */
class PublicacionesAdminList extends React.Component {
  state = {
    tipoKey: "ACTIVA",
    nuevaBusqueda: false,
    values: {},
    /** La publicacion que se esta mirando en el resumen, o null si esta cerrado. */
    resumen: null,
    totalACTIVA: 0,
    totalFINALIZADA: 0,
    totalPAUSADA: 0,
  };

  componentDidMount() {
    const { filtros } = this.props;

    if (filtros === undefined) this.props.traerFiltros();

    this.actualizarTotales();
  }

  /** Contadores de las solapas; siguen al filtro de vendedor. */
  actualizarTotales = () => {
    productoServiceTs.buscarTotalPublicacionesAdmin(
      this.state.values.vendedor?.id,
      (totales) => this.setState(totales)
    );
  };

  actualizar = () => {
    const ref = refDe(this.state.tipoKey);
    if (ref.current) ref.current.onQueryChange();
  };

  actualizarPageSize = (newPageSize) => {
    const ref = refDe(this.state.tipoKey);
    if (ref.current) ref.current.dataManager.changePageSize(newPageSize);
  };

  buscarData = (query, estado) => {
    return new Promise((resolve) => {
      if (this.state.nuevaBusqueda) query.page = 0;

      const valuesToSend = { ...this.state.values, estado };

      productoService
        .buscarAdmin(prepareDataSearch(query, "id", "DESC", valuesToSend))
        .then(
          (data) => {
            resolve({
              data: data.content ? data.content : [],
              page: query.page,
              totalCount: data ? data.totalElements : 0,
            });

            this.setState({ nuevaBusqueda: false });
            this.actualizarPageSize(query.pageSize);
          },
          (error) => {
            alertService.error(error);
            resolve({ data: [], page: query.page, totalCount: 0 });
          }
        );
    });
  };

  nuevaPublicacion = () => {
    history.push("/admin/addEditProducto");
  };

  editar = (producto) => {
    history.push("/admin/addEditProducto?id=" + producto.id);
  };

  ver = (producto) => {
    this.setState({ resumen: producto });
  };

  cerrarResumen = () => {
    this.setState({ resumen: null });
  };

  render() {
    if (!authService.hasAuthority("ADMIN")) {
      history.push("/");
    }

    const { filtros } = this.props;

    const tableStyle = {
      tableLayout: "auto",
      width: "100%",
      maxWidth: "100%",
      height: "auto",
      borderRadius: "1rem",
      border: "1px solid #d2d2d2",
      boxShadow: "none",
      backgroundColor: "inherit",
      color: "inherit",
    };

    const customSelect = {
      control: (provided) => ({
        ...provided,
        background: "transparent",
        borderColor: "transparent",
        height: "38px",
      }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    const header = [
      { title: "ID", field: "id", cellStyle: { width: "2%" } },
      {
        // El nombre del vendedor puede ser larguisimo (razon social + mail): se corta
        // con ellipsis y el nombre completo queda en el title.
        title: "Vendedor",
        field: "vendedor.username",
        render: (row) => {
          const nombre = authService.formatUserName(row.vendedor);
          return (
            <span className="mitabla__celda-truncada" title={nombre}>
              {nombre}
            </span>
          );
        },
      },
      {
        title: "Tipo Repuesto",
        field: "tipoRepuesto.nombre",
        render: (row) => (
          <>
            {row.tipoRepuesto?.nombre}
            {row.tipoRepuesto?.nombre === TIPO_REPUESTO.MOTOR_04 && (
              <MyToolTip
                texto={productoServiceTs.crearNombreMotorAsociados(row)}
                id={row.id.toString()}
              />
            )}
          </>
        ),
      },
      {
        // Marca / modelo / version / año eran 4 columnas: juntas desbordaban la tabla a
        // lo ancho. Van apiladas en una sola; el detalle completo sigue en el panel.
        title: "Vehículo",
        field: "marca.nombre",
        render: (row) => {
          const detalle = [row.modelo?.nombre, row.version?.nombre, row.anio]
            .filter(Boolean)
            .join(" · ");

          return (
            <div className="mitabla__celda-apilada">
              <span>{row.marca?.nombre}</span>
              {detalle && <small>{detalle}</small>}
            </div>
          );
        },
      },
      { title: "Estado", field: "estado" },
      {
        title: "Precio",
        field: "precio",
        // Igual que en el listado del vendedor: "$" a secas no dice si el precio falta
        // o si la publicacion es a consultar.
        render: (row) =>
          productoActions.esPrecioAConsultar(row) ? (
            <span>A consultar</span>
          ) : (
            <NumberFormat
              prefix="$"
              value={row.precio}
              displayType={"text"}
              thousandSeparator="."
              decimalSeparator=","
            />
          ),
      },
      {
        title: "",
        cellStyle: { textAlign: "center" },
        render: (row) => (
          <div className="table-button">
            <Button
              className="button"
              data-type="complementary-smallest"
              variant="primary"
              onClick={() => this.ver(row)}
              title="Ver resumen"
              aria-label="Ver resumen de la publicación"
            >
              <FontAwesomeIcon icon="fa-solid fa-eye" />
            </Button>
            <Button
              className="button"
              data-type="complementary-smallest"
              variant="primary"
              onClick={() => this.editar(row)}
              title="Editar"
              aria-label="Editar la publicación"
            >
              <FontAwesomeIcon icon="fa-solid fa-pen" />
            </Button>
          </div>
        ),
      },
    ];

    const options = {
      search: true,
      sorting: true,
      fontSize: 6,
      filtering: false,
      selection: false,
      pageSize: 10,
      pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
      exportAllData: true,
      overflowX: "auto",
      tableLayout: "auto",
    };

    const inic = {
      vendedor: { id: undefined },
      marca: { id: undefined },
      modelo: { id: undefined },
      tipoRepuesto: { id: undefined },
    };

    return (
      <>
      <div className="dashboard">
        <NavBarLateral />
        <div className="dashboard__content">
          <Formik
            enableReinitialize={true}
            innerRef={bagRef}
            initialValues={inic}
            onSubmit={(values) => {
              this.setState({ values: values, nuevaBusqueda: true }, () => {
                this.actualizar();
                this.actualizarTotales();
              });
            }}
          >
            {({ values, setFieldValue, submitForm }) => (
              <Form>
                <div className="dashboard__content-header">
                  <div className="dashboard__content-title">
                    <h2>Publicaciones (todos los vendedores)</h2>
                  </div>
                </div>

                <div className="filter__container">
                  <div className="filterstart">
                    <div className="filterby_container">
                      <span>Vendedor: </span>
                      <Select
                        className="filter_select"
                        styles={customSelect}
                        isClearable={true}
                        value={
                          (filtros?.vendedores || []).find(
                            (option) => option.id === values.vendedor?.id
                          ) || null
                        }
                        placeholder="Todos"
                        getOptionLabel={(option) =>
                          authService.formatUserName(option)
                        }
                        getOptionValue={(option) => option.id}
                        options={filtros?.vendedores}
                        onChange={(opt) => {
                          setFieldValue("vendedor", opt || { id: undefined });
                          submitForm();
                        }}
                        components={{ IndicatorSeparator: () => null }}
                      />
                    </div>

                    <FiltrosDashboard
                      forPublicacion={true}
                      values={values}
                      filtros={filtros}
                      setFieldValue={setFieldValue}
                      submitForm={submitForm}
                    />
                  </div>
                  <div className="filterend">
                    <Button
                      className="button"
                      type="button"
                      data-type="primary"
                      onClick={this.nuevaPublicacion}
                    >
                      Nueva publicación
                    </Button>
                  </div>
                </div>

                <Tabs
                  mountOnEnter={true}
                  id="publicaciones-admin-tabs"
                  activeKey={this.state.tipoKey}
                  onSelect={(k) =>
                    this.setState({ tipoKey: k, nuevaBusqueda: true })
                  }
                >
                  {SOLAPAS.map(({ estado, titulo }) => (
                    <Tab
                      key={estado}
                      eventKey={estado}
                      title={`${titulo} (${this.state["total" + estado]})`}
                    >
                      <div className="dashboard__content-main--tab">
                        <MiTabla
                          title=""
                          tableRef={refDe(estado)}
                          columns={header}
                          options={options}
                          style={tableStyle}
                          data={(query) => this.buscarData(query, estado)}
                          detailPanel={(rowData) => (
                            <ProductoDP rowData={rowData} editar={this.editar} />
                          )}
                          localization={traerPalabrasTabla("Publicación")}
                        />
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      {this.state.resumen && (
        <ResumenPublicacionModal
          producto={this.state.resumen}
          onHide={this.cerrarResumen}
          onEditar={this.editar}
          cargarDetalle={buscadorService.buscarProductoPorIdBackOffice}
        />
      )}
      </>
    );
  }
}

function mapState(state) {
  const { filtros } = state.busqueda;
  return { filtros };
}

const actionCreators = {
  traerFiltros: busquedaActions.traerFiltros,
};

const connectedPublicacionesAdminList = connect(
  mapState,
  actionCreators
)(PublicacionesAdminList);
export { connectedPublicacionesAdminList as PublicacionesAdminList };
